var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainTab",style:({backgroundColor:_vm.getBackgroundColor})},[_c('div',{staticClass:"mainTab"},[_c('div',{staticClass:"tab-header"},[_c('div',{staticClass:"tab-wrapper"},[_c('div',{staticClass:"no-scroll"},[_c('div',{staticClass:"nav",staticStyle:{"display":"flex"},style:({flexDirection:_vm.direction}),attrs:{"role":"tablist"}},_vm._l((_vm.chartConfig.data),function(item,index){return _c('div',{key:index,staticClass:"item",staticStyle:{"background-size":"100% 100%","background-repeat":"no-repeat"},style:({color:_vm.getFontColor(item.id),fontSize:_vm.getFontSize,
              borderBottom:_vm.getBorderBottomColor(item.id),
              borderTop:_vm.getBorderTopColor(item.id),
              borderLeft:_vm.getBorderLeftColor(item.id),
              borderRight:_vm.getBorderRightColor(item.id),
              margin:_vm.getMargin,
              padding:_vm.getPadding,
              height:_vm.getItemHeight,
              backgroundImage:'url('+_vm.getBackgroundImage(item)+') ',

              width:_vm.getItemWidth}),attrs:{"data-name":item.id},on:{"click":function($event){return _vm.tabClick(item.id)}}},[_vm._v("\n              "+_vm._s(item.label?item.label:'')+"\n            ")])}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1292bf","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs.vue
// module id = 866
// module chunks = 0